import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';

const middleware = applyMiddleware(
    thunk
);

const store = createStore(
    rootReducer, 
    middleware
);

// expose store only in dev mode
if(process.env.NODE_ENV === 'development') window.store = store;

export default store;




// WEBPACK FOOTER //
// ./src/store/index.js